
"use client";

import React, { useState } from "react";
import "./CompleteTheLookPost.css";

const API_URL =
  "https://api.malidag.com/api/complete-the-look";

const emptyItem = () => ({
  itemId: "",
  color: "",
});

export default function CompleteTheLookPost() {
  const [mainItemId, setMainItemId] = useState("");
  const [items, setItems] = useState([emptyItem()]);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [mainColor, setMainColor] = useState("");

  const updateItem = (index, field, value) => {
    setItems((previous) =>
      previous.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const addItem = () => {
    setItems((previous) => [...previous, emptyItem()]);
  };

  const removeItem = (index) => {
    setItems((previous) =>
      previous.filter((_, i) => i !== index)
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setMessage("");
    setError("");

    const cleanMainId = mainItemId.trim();

    const cleanMainColor = mainColor.trim();

if (!cleanMainColor) {
  setError("Please enter the main product color.");
  return;
}

    const cleanItems = items.map((item) => ({
      itemId: item.itemId.trim(),
      color: item.color.trim(),
    }));

    if (!cleanMainId) {
      setError("Please enter the main product itemId.");
      return;
    }

    if (
      !cleanItems.length ||
      cleanItems.some((item) => !item.itemId || !item.color)
    ) {
      setError(
        "Each related product must have an itemId and color."
      );
      return;
    }

    const ids = cleanItems.map((item) => item.itemId);

    if (new Set(ids).size !== ids.length) {
      setError("Duplicate related itemIds are not allowed.");
      return;
    }

    if (ids.includes(cleanMainId)) {
      setError("The main product cannot recommend itself.");
      return;
    }

    try {
      setSaving(true);

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
       body: JSON.stringify({
  itemId: cleanMainId,
  color: cleanMainColor,
  items: cleanItems,
}),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.error || "Failed to save Complete the Look."
        );
      }

      setMessage("Complete the Look saved successfully!");
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="ctl-admin">
      <div className="ctl-admin-header">
        <h2>Complete the Look</h2>
        <p>
          Connect products together and choose the exact
          color to display for each recommended item.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ctl-admin-main-field">
          <label htmlFor="ctl-main-id">
            Main product itemId
          </label>

          <input
            id="ctl-main-id"
            type="text"
            placeholder="Enter main product itemId"
            value={mainItemId}
            onChange={(e) =>
              setMainItemId(e.target.value)
            }
            required
          />
        </div>

        <div className="ctl-admin-main-field">
  <label htmlFor="ctl-main-color">Main product color</label>

  <input
    id="ctl-main-color"
    type="text"
    placeholder="e.g. Asphalt, Black, Beige"
    value={mainColor}
    onChange={(e) => setMainColor(e.target.value)}
    required
  />
</div>

        <div className="ctl-admin-list-heading">
          <h3>Related products</h3>

          <span>
            {items.length} item{items.length !== 1 ? "s" : ""}
          </span>
        </div>

        <div className="ctl-admin-items">
          {items.map((item, index) => (
            <div className="ctl-admin-item" key={index}>
              <div className="ctl-admin-item-number">
                {index + 1}
              </div>

              <div className="ctl-admin-field">
                <label htmlFor={`ctl-item-${index}`}>
                  Item ID
                </label>

                <input
                  id={`ctl-item-${index}`}
                  type="text"
                  placeholder="Related itemId"
                  value={item.itemId}
                  onChange={(e) =>
                    updateItem(
                      index,
                      "itemId",
                      e.target.value
                    )
                  }
                  required
                />
              </div>

              <div className="ctl-admin-field">
                <label htmlFor={`ctl-color-${index}`}>
                  Color
                </label>

                <input
                  id={`ctl-color-${index}`}
                  type="text"
                  placeholder="e.g. Black"
                  value={item.color}
                  onChange={(e) =>
                    updateItem(
                      index,
                      "color",
                      e.target.value
                    )
                  }
                  required
                />
              </div>

              <button
                type="button"
                className="ctl-admin-remove"
                onClick={() => removeItem(index)}
                aria-label={`Remove item ${index + 1}`}
                title="Remove item"
              >
                ×
              </button>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="ctl-admin-add"
          onClick={addItem}
        >
          + Add another product
        </button>

        {error && (
          <div className="ctl-admin-error" role="alert">
            {error}
          </div>
        )}

        {message && (
          <div className="ctl-admin-success" role="status">
            {message}
          </div>
        )}

        <button
          type="submit"
          className="ctl-admin-submit"
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Complete the Look"}
        </button>
      </form>
    </section>
  );
}
